(function () {
  "use strict";

  /* =========================================================
     SHOPIFY HELPERS
  ========================================================= */

  const root =
    window.Shopify && Shopify.routes
      ? Shopify.routes.root
      : "/";

  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof Shopify.formatMoney === "function"
    ) {
      return Shopify.formatMoney(cents);
    }

    return (
      "₹" +
      (Number(cents) / 100).toLocaleString("en-IN", {
        maximumFractionDigits: 2
      })
    );
  }


  /* =========================================================
     ADD TO CART
  ========================================================= */

  async function addToCart(variantId, button) {

    if (!variantId || !button) return;

    if (button.classList.contains("is-loading")) return;

    button.classList.add("is-loading");

    const originalText = button.textContent.trim();

    button.textContent = "Adding...";

    try {

      const response = await fetch(
        root + "cart/add.js",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "Accept": "application/json"
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) {

        let errorMessage = "Unable to add product";

        try {
          const errorData = await response.json();

          if (errorData && errorData.description) {
            errorMessage = errorData.description;
          }

        } catch (e) {}

        throw new Error(errorMessage);
      }


      /* =====================================================
        GET UPDATED CART
      ===================================================== */

      const cartResponse = await fetch(
        root + "cart.js",
        {
          headers: {
            "Accept": "application/json"
          }
        }
      );

      if (!cartResponse.ok) {
        throw new Error("Unable to refresh cart");
      }

      const cart = await cartResponse.json();

      const itemCount = Number(
        cart.item_count || 0
      );


      /* =====================================================
        UPDATE CART BUBBLE
      ===================================================== */

      updateAbhiCartCount(itemCount);


      /* =====================================================
        UPDATE HORIZON CART COMPONENT
      ===================================================== */

      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,

          detail: {
            resource: cart,

            sourceId:
              "abhiramam-product-card",

            data: {
              itemCount: itemCount,
              source:
                "abhiramam-product-card"
            }
          }
        })
      );


      /* =====================================================
        SUCCESS
      ===================================================== */

      button.textContent = "Added to Bag";

      button.classList.add("is-success");


      document.dispatchEvent(
        new CustomEvent(
          "abhi:cart-updated",
          {
            bubbles: true,

            detail: {
              cart: cart
            }
          }
        )
      );


      setTimeout(function () {

        button.textContent = originalText;

        button.classList.remove(
          "is-success"
        );

      }, 1500);


    } catch (error) {

      console.error(
        "Abhiramam Add to Cart Error:",
        error
      );

      button.textContent =
        error.message || "Try Again";


      setTimeout(function () {

        button.textContent = originalText;

      }, 2000);


    } finally {

      button.classList.remove(
        "is-loading"
      );

    }

  }

  function updateAbhiCartCount(itemCount) {

    const count = Number(itemCount || 0);


    /*
    * Horizon / Shopify cart bubble
    */

    document
      .querySelectorAll(
        ".cart-bubble__text-count"
      )
      .forEach(function (element) {

        element.textContent =
          count > 0 ? count : "";

      });


    /*
    * Keep cart icon state correct
    */

    document
      .querySelectorAll(
        ".header-actions__cart-icon"
      )
      .forEach(function (element) {

        element.classList.toggle(
          "header-actions__cart-icon--has-cart",
          count > 0
        );

      });


    /*
    * Generic fallback selectors
    */

    document
      .querySelectorAll(
        "[data-cart-count], [data-cart-count-bubble]"
      )
      .forEach(function (element) {

        element.textContent = count;

      });


    /*
    * Wishlist/header/cart custom event
    */

    document.dispatchEvent(
      new CustomEvent(
        "abhi:cart-count-updated",
        {
          bubbles: true,
          detail: {
            count: count
          }
        }
      )
    );

  }


  function bindAddToCart() {

    document
      .querySelectorAll(
        "[data-abhi-add-to-cart]"
      )
      .forEach(
        function (button) {

          if (
            button.dataset.abhiBound ===
            "true"
          ) {
            return;
          }

          button.dataset.abhiBound =
            "true";

          button.addEventListener(
            "click",
            function () {

              addToCart(
                button.dataset.variantId,
                button
              );

            }
          );

        }
      );

  }


  /* =========================================================
     WISHLIST NATIVE ADD TO CART — SUCCESS FEEDBACK
     ---------------------------------------------------------
     The Wishlist Page and Wishlist Drawer "Add to Bag" buttons
     now submit through Shopify/Horizon's native
     <product-form-component> / <add-to-cart-component> system
     instead of the old custom addToCart() function, so the old
     "Added to Bag" text/success-state code no longer runs for
     them.

     Horizon's exact success event name/target can vary by
     theme version, so rather than depending on it we confirm
     the add the same way the rest of this file already talks
     to Shopify: by reading cart.js. We snapshot the cart item
     count right when the button is clicked, then poll cart.js
     a few times afterwards; as soon as the count goes up we
     show "Added to Bag" on that exact button. This works no
     matter which internal event (if any) Horizon dispatches.
  ========================================================= */

  let abhiWishlistFeedbackBound = false;


  function bindWishlistNativeAddToCartFeedback() {

    if (abhiWishlistFeedbackBound) {
      return;
    }

    abhiWishlistFeedbackBound = true;


    document.addEventListener(
      "click",
      function (event) {

        const button =
          event.target.closest(
            ".abhi-wishlist-card__add[type=\"submit\"], .abhi-wishlist-drawer__add[type=\"submit\"]"
          );

        if (!button) {
          return;
        }

        if (button.disabled) {
          return;
        }

        confirmWishlistAddToCart(button);

      },
      true
    );


    /*
     * If Horizon *does* dispatch cart:update, use it as a
     * faster, more accurate confirmation than polling.
     */

    document.addEventListener(
      "cart:update",
      function () {

        if (
          !abhiWishlistPendingButtons.size
        ) {
          return;
        }

        abhiWishlistPendingButtons.forEach(
          function (button) {

            showWishlistAddSuccess(
              button
            );

          }
        );

        abhiWishlistPendingButtons.clear();

      }
    );

  }


  const abhiWishlistPendingButtons =
    new Set();


  async function confirmWishlistAddToCart(
    button
  ) {

    if (
      abhiWishlistPendingButtons.has(
        button
      )
    ) {
      return;
    }

    abhiWishlistPendingButtons.add(
      button
    );


    let beforeCount = null;


    try {

      const beforeResponse =
        await fetch(
          root + "cart.js",
          {
            headers: {
              Accept: "application/json"
            }
          }
        );

      if (beforeResponse.ok) {

        const beforeCart =
          await beforeResponse.json();

        beforeCount = Number(
          beforeCart.item_count || 0
        );

      }

    } catch (error) {}


    const maxAttempts = 6;

    let attempts = 0;


    const poll = async function () {

      attempts++;


      if (
        !abhiWishlistPendingButtons.has(
          button
        )
      ) {
        /* Already confirmed via cart:update */
        return;
      }


      try {

        const response =
          await fetch(
            root + "cart.js",
            {
              headers: {
                Accept: "application/json"
              }
            }
          );

        if (response.ok) {

          const cart =
            await response.json();

          const currentCount = Number(
            cart.item_count || 0
          );


          if (
            beforeCount === null ||
            currentCount > beforeCount
          ) {

            abhiWishlistPendingButtons.delete(
              button
            );

            showWishlistAddSuccess(
              button
            );

            return;

          }

        }

      } catch (error) {}


      if (attempts < maxAttempts) {

        setTimeout(poll, 400);

      } else {

        abhiWishlistPendingButtons.delete(
          button
        );

      }

    };


    setTimeout(poll, 350);

  }


  function showWishlistAddSuccess(
    button
  ) {

    const originalText =
      button.dataset.abhiOriginalText ||
      button.textContent.trim();

    button.dataset.abhiOriginalText =
      originalText;

    button.textContent = "Added to Bag";

    button.classList.add("is-success");

    setTimeout(function () {

      button.textContent = originalText;

      button.classList.remove(
        "is-success"
      );

    }, 1500);

  }


  /* =========================================================
     NATIVE HORIZON ADD TO CART FORM (WISHLIST ONLY)
     ---------------------------------------------------------
     Generates the same native Shopify/Horizon product-form
     markup used by the homepage product cards, so that
     Wishlist Page and Wishlist Drawer "Add to Bag" buttons
     use the native <product-form-component> /
     <add-to-cart-component> architecture instead of the old
     custom addToCart()/bindAddToCart() implementation.
  ========================================================= */

  function buildNativeAddToCartMarkup(product, variant, options) {

    const opts = options || {};

    const formClass = opts.formClass || "";
    const buttonClass = opts.buttonClass || "abhi-add-to-bag";
    const sectionId = opts.sectionId || "abhiramam-wishlist";

    if (!variant || !variant.available) {

      return `
        <button
          type="button"
          class="${buttonClass}"
          disabled
        >
          Sold Out
        </button>
      `;

    }

    const productId = product && product.id ? product.id : "";
    const productUrl = product && product.url ? product.url : "";

    return `
      <product-form-component
        class="${formClass}"
        data-section-id="${sectionId}"
        data-product-id="${productId}"
        data-product-url="${escapeHTML(productUrl)}"
        on:submit="/handleSubmit"
      >

        <div
          class="visually-hidden"
          aria-live="assertive"
          role="status"
          aria-atomic="true"
          ref="liveRegion"
        ></div>

        <form
          method="post"
          action="${root}cart/add"
          accept-charset="UTF-8"
          enctype="multipart/form-data"
          novalidate
          data-type="add-to-cart-form"
        >

          <input
            type="hidden"
            name="id"
            ref="variantId"
            value="${variant.id}"
          >

          <input
            type="hidden"
            name="quantity"
            value="1"
          >

          <add-to-cart-component
            ref="addToCartButtonContainer"
          >
            <button
              type="submit"
              name="add"
              ref="addToCartButton"
              class="${buttonClass}"
              on:click="/handleClick"
            >
              Add to Bag
            </button>
          </add-to-cart-component>

        </form>

      </product-form-component>
    `;

  }


  /* =========================================================
     WISHLIST
  ========================================================= */

  const ABHI_WISHLIST_KEY =
    "abhiramam_wishlist";

  /* =========================================================
    RECENTLY VIEWED
  ========================================================= */

  const ABHI_RECENTLY_VIEWED_KEY =
    "abhiramam_recently_viewed";


  function getRecentlyViewed() {

    try {

      const saved =
        localStorage.getItem(
          ABHI_RECENTLY_VIEWED_KEY
        );

      if (!saved) {
        return [];
      }

      const parsed =
        JSON.parse(saved);

      return Array.isArray(parsed)
        ? parsed
        : [];

    } catch (error) {

      console.warn(
        "Recently viewed read error:",
        error
      );

      return [];

    }

  }


  function saveRecentlyViewed(items) {

    try {

      localStorage.setItem(
        ABHI_RECENTLY_VIEWED_KEY,
        JSON.stringify(items)
      );

    } catch (error) {

      console.warn(
        "Recently viewed save error:",
        error
      );

    }

  }


  function addRecentlyViewed(handle) {

    if (!handle) {
      return;
    }

    let items =
      getRecentlyViewed();


    /*
    * Remove existing occurrence so the
    * latest viewed product goes to the front.
    */
    items =
      items.filter(
        function (item) {
          return item !== handle;
        }
      );


    /*
    * Put newest product first.
    */
    items.unshift(handle);


    /*
    * Keep the latest 10 products.
    */
    items =
      items.slice(0, 10);


    saveRecentlyViewed(items);

  }

  function trackCurrentProductView() {

    const path =
      window.location.pathname || "";


    /*
    * Only run on Shopify product URLs.
    *
    * Example:
    * /products/my-saree
    */
    const match =
      path.match(
        /^\/products\/([^\/]+)/
      );


    if (!match) {
      return;
    }


    const handle =
      decodeURIComponent(
        match[1]
      );


    if (handle) {

      addRecentlyViewed(
        handle
      );

    }

  }

  async function renderRecentlyViewed() {

    const container =
      document.querySelector(
        "[data-abhi-recently-viewed]"
      );

    if (!container) {
      return;
    }


    const handles =
      getRecentlyViewed();


    /*
    * No recently viewed products
    */

    if (!handles.length) {

      container.innerHTML = "";

      return;

    }


    /*
    * Load the same product card
    * used everywhere else.
    */

    const renderedCards =
      (
        await Promise.all(

          handles.map(

            async function (handle) {

              try {

                const response =
                  await fetch(
                    root +
                    "products/" +
                    encodeURIComponent(handle) +
                    "?section_id=abhi-wishlist-product-card"
                  );


                if (!response.ok) {
                  return "";
                }


                const html =
                  await response.text();


                const parser =
                  new DOMParser();


                const documentFragment =
                  parser.parseFromString(
                    html,
                    "text/html"
                  );


                const card =
                  documentFragment.querySelector(
                    ".abhi-product-card"
                  );


                if (!card) {
                  return "";
                }


                return card.outerHTML;


              } catch (error) {

                console.warn(
                  "Recently viewed product could not be rendered:",
                  handle,
                  error
                );

                return "";

              }

            }

          )

        )
      ).filter(Boolean);


    container.innerHTML =
      renderedCards.join("");


    /*
    * Re-bind product-card features
    */

    bindWishlist();

    bindQuickView();

  }


  function getWishlist() {

    try {

      const saved =
        localStorage.getItem(
          ABHI_WISHLIST_KEY
        );

      if (!saved) {
        return [];
      }

      const parsed =
        JSON.parse(saved);

      return Array.isArray(parsed)
        ? parsed
        : [];

    } catch (error) {

      console.warn(
        "Wishlist read error:",
        error
      );

      return [];

    }

  }


  function saveWishlist(items) {

    try {

      localStorage.setItem(
        ABHI_WISHLIST_KEY,
        JSON.stringify(items)
      );

    } catch (error) {

      console.warn(
        "Wishlist save error:",
        error
      );

    }

  }


  function updateWishlistButtons() {

    const wishlist =
      getWishlist();

    document
      .querySelectorAll(
        "[data-abhi-wishlist]"
      )
      .forEach(
        function (button) {

          const handle =
            button.dataset.productHandle;

          const active =
            wishlist.includes(handle);

          button.classList.toggle(
            "is-active",
            active
          );

          button.setAttribute(
            "aria-pressed",
            active
              ? "true"
              : "false"
          );

          button.setAttribute(
            "aria-label",
            active
              ? "Remove from wishlist"
              : "Add to wishlist"
          );

        }
      );

  }

  function updateWishlistHeaderCount() {

    const wishlist =
      getWishlist();

    const count =
      wishlist.length;

    document
      .querySelectorAll(
        "[data-abhi-wishlist-count]"
      )
      .forEach(function (element) {

        element.textContent =
          count > 0 ? count : "";

        element.classList.toggle(
          "is-visible",
          count > 0
        );

      });

  }


  function bindWishlist() {

    document
      .querySelectorAll(
        "[data-abhi-wishlist]"
      )
      .forEach(
        function (button) {

          if (
            button.dataset.abhiBound ===
            "true"
          ) {
            return;
          }

          button.dataset.abhiBound =
            "true";


          button.addEventListener(
            "click",
            function () {

              const handle =
                button.dataset.productHandle;

              if (!handle) return;


              let wishlist =
                getWishlist();


              const existingIndex =
                wishlist.indexOf(
                  handle
                );


              if (
                existingIndex === -1
              ) {

                wishlist.push(
                  handle
                );

              } else {

                wishlist.splice(
                  existingIndex,
                  1
                );

              }


              saveWishlist(
                wishlist
              );

              updateWishlistButtons();

              updateWishlistCount();


              /*
               * syncWishlistViews() listens for this event and
               * updates the wishlist page grid + drawer live.
               */
              document.dispatchEvent(
                new CustomEvent(
                  "abhi:wishlist-updated",
                  {
                    bubbles: true,

                    detail: {
                      wishlist:
                        wishlist
                    }
                  }
                )
              );

            }
          );

        }
      );


    updateWishlistButtons();

    updateWishlistCount();

  }


  function updateWishlistCount() {
    const wishlist = getWishlist();
    const count = wishlist.length;

    document
      .querySelectorAll("[data-abhi-wishlist-count]")
      .forEach(function (element) {
        element.textContent = count > 0 ? count : "";

        element.classList.toggle(
          "is-visible",
          count > 0
        );
      });
  }


  /* =========================================================
     WISHLIST REMOVE (drawer trash button)
  ========================================================= */

  function bindWishlistRemove() {

    document
      .querySelectorAll("[data-abhi-wishlist-remove]")
      .forEach(function (button) {

        if (button.dataset.abhiRemoveBound === "true") {
          return;
        }

        button.dataset.abhiRemoveBound = "true";

        button.addEventListener("click", function (event) {

          event.preventDefault();
          event.stopPropagation();

          const handle = button.dataset.productHandle;

          if (!handle) return;

          const wishlist = getWishlist().filter(function (item) {
            return item !== handle;
          });

          saveWishlist(wishlist);

          updateWishlistButtons();
          updateWishlistCount();

          /* syncWishlistViews() picks this up and updates the UI */
          document.dispatchEvent(
            new CustomEvent("abhi:wishlist-updated", {
              bubbles: true,
              detail: { wishlist: wishlist }
            })
          );

        });

      });

  }


  /* =========================================================
     WISHLIST LIVE SYNC (page grid + drawer)
     ---------------------------------------------------------
     Runs whenever "abhi:wishlist-updated" fires, so removing
     an item from the heart button, the page, or the drawer
     updates every view instantly with no page refresh.
  ========================================================= */

  /* Handles currently being fetched/appended to the wishlist page */
  const abhiWishlistAppending = new Set();

  async function appendWishlistPageCards(grid, empty, handles) {

    handles.forEach(function (handle) {
      abhiWishlistAppending.add(handle);
    });

    try {

      const results = await Promise.all(

        handles.map(async function (handle) {

          try {

            const base =
              root + "products/" + encodeURIComponent(handle);

            const responses = await Promise.all([
              fetch(base + ".js"),
              fetch(base + "?section_id=abhi-wishlist-product-card")
            ]);

            if (!responses[0].ok || !responses[1].ok) {
              return null;
            }

            const product = await responses[0].json();
            const html = await responses[1].text();

            const parsed =
              new DOMParser().parseFromString(html, "text/html");

            const card = parsed.querySelector(".abhi-product-card");

            if (!card) {
              return null;
            }

            card.setAttribute("data-wishlist-page-card", "");

            applyRecentlyViewedOptions(card, {
              imageRadius: grid.dataset.imageRadius,
              imageRatio: grid.dataset.imageRatio
            });

            return { handle: handle, product: product, html: card.outerHTML };

          } catch (error) {

            console.warn(
              "Wishlist card could not be added live:",
              handle,
              error
            );

            return null;

          }

        })

      );

      /* Only add what is still wishlisted and not already on the page */
      const current = getWishlist();

      const toAdd = results.filter(function (item) {

        if (!item || !current.includes(item.handle)) {
          return false;
        }

        const alreadyShown = Array.from(
          grid.querySelectorAll("[data-wishlist-page-card] [data-abhi-wishlist]")
        ).some(function (heart) {
          return heart.dataset.productHandle === item.handle;
        });

        return !alreadyShown;

      });

      if (toAdd.length) {

        const loading = grid.querySelector(".abhi-wishlist-page__loading");

        if (loading) {
          loading.remove();
        }

        empty.hidden = true;

        grid.insertAdjacentHTML(
          "beforeend",
          toAdd.map(function (item) { return item.html; }).join("")
        );

        bindWishlist();

        bindQuickView();

        bindAddToCart();

        initializeJudgeMeBadgesFor(
          grid,
          toAdd.map(function (item) { return item.product; })
        );

      }

    } finally {

      handles.forEach(function (handle) {
        abhiWishlistAppending.delete(handle);
      });

    }

  }


  function syncWishlistViews() {

    const wishlist = getWishlist();

    /* ---------- Wishlist page ---------- */

    const grid = document.querySelector("[data-abhi-wishlist-page]");
    const empty = document.querySelector("[data-abhi-wishlist-empty]");

    if (grid && empty) {

      const shownHandles = [];

      /* Remove cards that are no longer in the wishlist */
      grid
        .querySelectorAll("[data-wishlist-page-card]")
        .forEach(function (card) {

          const heart = card.querySelector("[data-abhi-wishlist]");
          const handle = heart && heart.dataset.productHandle;

          if (handle && !wishlist.includes(handle)) {
            card.remove();
          } else if (handle) {
            shownHandles.push(handle);
          }

        });

      /*
       * Add cards for products that were just added to the wishlist
       * (e.g. from "You may also like" / "Recently viewed") but are
       * not in the page grid yet.
       */
      const missing = wishlist.filter(function (handle) {
        return (
          !shownHandles.includes(handle) &&
          !abhiWishlistAppending.has(handle)
        );
      });

      if (missing.length && !abhiWishlistPageRendering) {
        appendWishlistPageCards(grid, empty, missing);
      }

      const hasCards = grid.querySelector("[data-wishlist-page-card]");
      const isLoading = grid.querySelector(".abhi-wishlist-page__loading");

      if (!hasCards && !isLoading && !abhiWishlistAppending.size) {
        grid.innerHTML = "";
        empty.hidden = false;
      }

    }

    /* ---------- Wishlist drawer (only if open) ---------- */

    const drawer = document.querySelector(
      "[data-abhi-wishlist-drawer].is-open"
    );

    if (drawer) {

      drawer
        .querySelectorAll("[data-wishlist-drawer-item]")
        .forEach(function (item) {

          if (!wishlist.includes(item.dataset.productHandle)) {
            item.remove();
          }

        });

      const countElement = drawer.querySelector(
        "[data-abhi-wishlist-drawer-count]"
      );

      if (countElement) {
        countElement.textContent = wishlist.length;
      }

      const shown = drawer.querySelectorAll(
        "[data-wishlist-drawer-item]"
      ).length;

      /* Empty state, or something was added: do a full re-render */
      if (!wishlist.length || shown !== wishlist.length) {
        renderWishlistDrawer();
      }

    }

  }

  /* Registered once at file level (not inside initAbhiTheme) */
  document.addEventListener("abhi:wishlist-updated", syncWishlistViews);


  /* =========================================================
     WISHLIST PAGE
  ========================================================= */

  function escapeHTML(value) {

    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  }

  function initializeJudgeMeBadgesFor(container, products) {

    function attempt() {

      if (!container) return false;

      if (
        !window.jdgm ||
        typeof window.jdgm.batchRenderBadges !== "function"
      ) {
        return false;
      }

      const handleById = {};

      products.forEach(function (product) {
        if (product && product.id != null) {
          handleById[String(product.id)] = product.handle;
        }
      });

      const widgets =
        container.querySelectorAll(".jdgm-widget.jdgm-preview-badge");

      const items =
        Array.from(widgets)
          .map(function (widget) {

            const handle = handleById[widget.dataset.id];

            if (!handle) {
              return null;
            }

            return {
              productHandle: handle,
              badgePlaceholder: widget
            };

          })
          .filter(Boolean);

      if (!items.length) {
        return false;
      }

      try {

        window.jdgm.batchRenderBadges(items);

      } catch (error) {

        console.warn(
          "Judge.me badge render error:",
          error
        );

        return false;

      }

      return true;

    }

    if (attempt()) {
      return;
    }

    let attempts = 0;

    const retry = setInterval(function () {

      attempts += 1;

      if (attempt() || attempts >= 10) {
        clearInterval(retry);
      }

    }, 500);

  }

  let abhiWishlistPageRendering = false;

  async function renderWishlistPage() {

    if (abhiWishlistPageRendering) {
      return;
    }

    abhiWishlistPageRendering = true;

    try {

      const grid =
        document.querySelector(
          "[data-abhi-wishlist-page]"
        );

      const empty =
        document.querySelector(
          "[data-abhi-wishlist-empty]"
        );

      if (!grid || !empty) {
        return;
      }

      const wishlist =
        getWishlist();

      grid.innerHTML = "";

      empty.hidden = true;

      if (!wishlist.length) {

        empty.hidden = false;

        return;

      }

      grid.innerHTML =
        '<div class="abhi-wishlist-page__loading">Loading your wishlist...</div>';


      /*
       * =========================================================
       * STEP 2
       * Validate products through Shopify product JSON
       * =========================================================
       */

      const products =
        (
          await Promise.all(

            wishlist.map(
              async function (handle) {

                try {

                  const url =
                    root +
                    "products/" +
                    encodeURIComponent(handle) +
                    ".js";

                  const response =
                    await fetch(url);

                  if (!response.ok) {
                    return null;
                  }

                  return await response.json();

                } catch (error) {

                  console.warn(
                    "Wishlist product JSON could not be loaded:",
                    handle,
                    error
                  );

                  return null;

                }

              }
            )

          )
        ).filter(Boolean);


      /*
       * =========================================================
       * STEP 3
       * Validate wishlist handles
       * =========================================================
       */

      const validHandles =
        products.map(
          function (product) {
            return product.handle;
          }
        );

      if (validHandles.length !== wishlist.length) {

        saveWishlist(validHandles);

        updateWishlistButtons();

        updateWishlistCount();

      }

      if (!products.length) {

        grid.innerHTML = "";

        empty.hidden = false;

        return;

      }


      /*
       * =========================================================
       * STEP 4
       * Request Shopify Liquid-rendered product cards
       * =========================================================
       */

      const renderedCards =
        (
          await Promise.all(

            products.map(
              async function (product) {

                const sectionUrl =
                  root +
                  "products/" +
                  encodeURIComponent(product.handle) +
                  "?section_id=abhi-wishlist-product-card";

                try {

                  const response =
                    await fetch(sectionUrl);

                  if (!response.ok) {
                    return "";
                  }

                  const html =
                    await response.text();

                  const parser =
                    new DOMParser();

                  const parsed =
                    parser.parseFromString(html, "text/html");

                  const card =
                    parsed.querySelector(".abhi-product-card");

                  if (!card) {
                    return "";
                  }

                  card.setAttribute("data-wishlist-page-card", "");

                  /* Apply the wishlist section's image radius / ratio */
                  applyRecentlyViewedOptions(card, {
                    imageRadius: grid.dataset.imageRadius,
                    imageRatio: grid.dataset.imageRatio
                  });

                  return card.outerHTML;

                } catch (error) {

                  console.warn(
                    "Wishlist card could not be rendered:",
                    product.handle,
                    error
                  );

                  return "";

                }

              }
            )

          )
        ).filter(Boolean);


      /*
       * =========================================================
       * STEP 5
       * INSERT CARDS
       * =========================================================
       */

      grid.innerHTML =
        renderedCards.join("");


      /*
       * =========================================================
       * STEP 8
       * Event bindings + Judge.me
       * =========================================================
       */

      bindWishlist();

      bindQuickView();

      bindWishlistRemove();

      initializeJudgeMeBadgesFor(grid, products);

    } finally {

      abhiWishlistPageRendering = false;

    }

  }

  /* =========================================================
    RECENTLY VIEWED  (replacement)

    In abhiramam-reference.js there are TWO functions named
    renderRecentlyViewed. The second one (the one that starts with
    "const wrapper = document.querySelector('[data-abhi-recently-viewed]')"
    and ends with "initializeJudgeMeBadgesFor(grid, products);") is the
    one that actually runs. Replace that whole second function with
    everything below. Leave the first one alone.

    What changed:
    1. Works with more than one Recently Viewed on a page (the old one
        only filled the first).
    2. On a product page, the product being viewed is left out of the list.
    3. Each instance's own settings now apply: image radius, image ratio,
        and the show/hide toggles (rating, sale badge, wishlist, quick view,
        add to bag). Before, the cards ignored these.
  ========================================================= */

  function applyRecentlyViewedOptions(card, data) {

    const imageWrap =
      card.querySelector(".abhi-product-card__image-wrap");

    if (imageWrap) {

      let classes = imageWrap.className;

      if (data.imageRadius) {
        classes =
          classes.replace(
            /abhi-product-card__image-wrap--radius-\S+/g,
            ""
          ) +
          " abhi-product-card__image-wrap--radius-" +
          data.imageRadius;
      }

      if (data.imageRatio) {
        classes =
          classes.replace(
            /abhi-product-card__image-wrap--(portrait|square|landscape|adapt)(?=\s|$)/g,
            ""
          ) +
          " abhi-product-card__image-wrap--" +
          data.imageRatio;
      }

      imageWrap.className =
        classes.replace(/\s+/g, " ").trim();

    }

    const removals = [
      ["showRating", ".abhi-product-card__rating"],
      ["showSaleBadge", ".abhi-product-card__badge"],
      ["showWishlist", ".abhi-product-card__wishlist"],
      ["showQuickView", ".abhi-product-card__quick-view"],
      ["showAddToBag", ".abhi-product-card__form, .abhi-product-card__cart-icon-wrap"]
    ];

    removals.forEach(function (rule) {

      if (data[rule[0]] === "false") {

        card
          .querySelectorAll(rule[1])
          .forEach(function (element) {
            element.remove();
          });

      }

    });

  }

  async function renderRecentlyViewed() {

    const wrappers =
      Array.from(
        document.querySelectorAll(
          "[data-abhi-recently-viewed]"
        )
      );

    if (!wrappers.length) {
      return;
    }

    /* Leave the product being viewed out of its own list */
    const currentMatch =
      window.location.pathname.match(
        /\/products\/([^\/?#]+)/
      );

    const currentHandle =
      currentMatch
        ? decodeURIComponent(currentMatch[1])
        : null;

    const handles =
      getRecentlyViewed().filter(
        function (handle) {
          return handle !== currentHandle;
        }
      );

    /* Fetch each product / card once, even if several instances need it */
    const productCache = {};
    const cardCache = {};

    function loadProduct(handle) {

      if (!productCache[handle]) {

        productCache[handle] =
          fetch(
            root +
            "products/" +
            encodeURIComponent(handle) +
            ".js"
          )
            .then(function (response) {
              return response.ok
                ? response.json()
                : null;
            })
            .catch(function (error) {
              console.warn(
                "Recently viewed product could not be loaded:",
                handle,
                error
              );
              return null;
            });

      }

      return productCache[handle];

    }

    function loadCardHtml(handle, cardSection) {

      const cacheKey = cardSection + "|" + handle;

      if (!cardCache[cacheKey]) {

        cardCache[cacheKey] =
          fetch(
            root +
            "products/" +
            encodeURIComponent(handle) +
            "?section_id=" +
            cardSection
          )
            .then(function (response) {
              return response.ok
                ? response.text()
                : "";
            })
            .catch(function (error) {
              console.warn(
                "Recently viewed card could not be rendered:",
                handle,
                error
              );
              return "";
            });

      }

      return cardCache[cacheKey];

    }

    for (const wrapper of wrappers) {

      /*
      * Two card sections exist: the icon-on-image style
      * (abhi-wishlist-product-card) and the standard text
      * "Add to Bag" button style (abhi-recently-viewed-card).
      * The instance's own toggle picks which one to fetch.
      * If the attribute is missing, the icon style is used.
      */
      const cardSection =
        wrapper.dataset.cartIconOnImage === "false"
          ? "abhi-recently-viewed-card"
          : "abhi-wishlist-product-card";

      const grid =
        wrapper.querySelector(
          "[data-abhi-recently-viewed-grid]"
        );

      if (!grid) {
        continue;
      }

      grid.innerHTML = "";

      if (!handles.length) {
        continue;
      }

      const limit =
        Number(
          wrapper.dataset.productsToShow || 4
        );

      const products =
        (
          await Promise.all(
            handles
              .slice(0, limit)
              .map(loadProduct)
          )
        ).filter(Boolean);

      if (!products.length) {
        continue;
      }

      const renderedCards =
        (
          await Promise.all(
            products.map(
              async function (product) {

                const html =
                  await loadCardHtml(product.handle, cardSection);

                if (!html) {
                  return "";
                }

                const parsed =
                  new DOMParser().parseFromString(
                    html,
                    "text/html"
                  );

                const card =
                  parsed.querySelector(
                    ".abhi-product-card"
                  );

                if (!card) {
                  return "";
                }

                card.setAttribute(
                  "data-recently-viewed-card",
                  ""
                );

                applyRecentlyViewedOptions(
                  card,
                  wrapper.dataset
                );

                return card.outerHTML;

              }
            )
          )
        ).filter(Boolean);

      grid.innerHTML =
        renderedCards.join("");

      /* Re-bind interactive product-card features */
      bindWishlist();

      bindQuickView();

      bindAddToCart();

      /* Judge.me badges for the dynamically inserted cards */
      initializeJudgeMeBadgesFor(grid, products);

    }

  }

  /* =========================================================
    WISHLIST HEADER + DRAWER
  ========================================================= */

  let abhiWishlistDrawerProductCache = {};


  /* =========================================================
    CREATE WISHLIST DRAWER
  ========================================================= */

  function createWishlistDrawer() {

    if (
      document.querySelector(
        "[data-abhi-wishlist-drawer]"
      )
    ) {
      return;
    }

    const drawer =
      document.createElement("div");

    drawer.className =
      "abhi-wishlist-drawer";

    drawer.setAttribute(
      "data-abhi-wishlist-drawer",
      ""
    );

    drawer.setAttribute(
      "aria-hidden",
      "true"
    );

    drawer.innerHTML = `
      <div
        class="abhi-wishlist-drawer__overlay"
        data-abhi-wishlist-close
      ></div>

      <aside
        class="abhi-wishlist-drawer__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="abhi-wishlist-drawer-title"
      >

        <div class="abhi-wishlist-drawer__header">

          <div class="abhi-wishlist-drawer__heading">

            <h2 id="abhi-wishlist-drawer-title">
              Wishlist
            </h2>

            <span
              class="abhi-wishlist-drawer__count"
              data-abhi-wishlist-drawer-count
            >
              0
            </span>

          </div>

          <button
            type="button"
            class="abhi-wishlist-drawer__close"
            data-abhi-wishlist-close
            aria-label="Close wishlist"
          >
            <span aria-hidden="true">
              ×
            </span>
          </button>

        </div>


        <div
          class="abhi-wishlist-drawer__body"
          data-abhi-wishlist-drawer-body
        ></div>


        <div class="abhi-wishlist-drawer__footer">

          <a
            href="/pages/wishlist"
            class="abhi-wishlist-drawer__button abhi-wishlist-drawer__button--outline"
          >
            View Wishlist
          </a>

          <a
            href="${root}cart"
            class="abhi-wishlist-drawer__button abhi-wishlist-drawer__button--primary"
          >
            Go to Cart
          </a>

        </div>

      </aside>
    `;

    document.body.appendChild(drawer);


    drawer
      .querySelectorAll(
        "[data-abhi-wishlist-close]"
      )
      .forEach(function (element) {

        element.addEventListener(
          "click",
          closeWishlistDrawer
        );

      });

  }


  /* =========================================================
    OPEN WISHLIST DRAWER
  ========================================================= */

  function openWishlistDrawer() {

    createWishlistDrawer();

    const drawer =
      document.querySelector(
        "[data-abhi-wishlist-drawer]"
      );

    if (!drawer) {
      return;
    }

    drawer.setAttribute(
      "aria-hidden",
      "false"
    );

    drawer.classList.add(
      "is-open"
    );

    document.body.classList.add(
      "abhi-wishlist-drawer-open"
    );

    renderWishlistDrawer();

  }


  /* =========================================================
    CLOSE WISHLIST DRAWER
  ========================================================= */

  function closeWishlistDrawer() {

    const drawer =
      document.querySelector(
        "[data-abhi-wishlist-drawer]"
      );

    if (!drawer) {
      return;
    }

    drawer.setAttribute(
      "aria-hidden",
      "true"
    );

    drawer.classList.remove(
      "is-open"
    );

    document.body.classList.remove(
      "abhi-wishlist-drawer-open"
    );

  }


  /* =========================================================
    RENDER WISHLIST DRAWER
  ========================================================= */

  async function renderWishlistDrawer() {

    createWishlistDrawer();

    const drawer =
      document.querySelector(
        "[data-abhi-wishlist-drawer]"
      );

    if (!drawer) {
      return;
    }


    const body =
      drawer.querySelector(
        "[data-abhi-wishlist-drawer-body]"
      );


    const countElement =
      drawer.querySelector(
        "[data-abhi-wishlist-drawer-count]"
      );


    const wishlist =
      getWishlist();


    /* Update drawer count */

    if (countElement) {

      countElement.textContent = wishlist.length;

    }


    /* Empty wishlist */

    if (!wishlist.length) {

      body.innerHTML = `

        <div class="abhi-wishlist-drawer__empty">

          <div
            class="abhi-wishlist-drawer__empty-icon"
            aria-hidden="true"
          >
            ♡
          </div>

          <h3>
            Your wishlist is empty
          </h3>

          <p>
            Save your favourite sarees here for later.
          </p>

        </div>

      `;

      return;
    }


    /* Loading */

    body.innerHTML = `

      <div class="abhi-wishlist-drawer__loading">
        Loading your wishlist...
      </div>

    `;


    /* Load products */

    const products =
      (
        await Promise.all(

          wishlist.map(
            async function (handle) {

              if (
                abhiWishlistDrawerProductCache[
                  handle
                ]
              ) {

                return (
                  abhiWishlistDrawerProductCache[
                    handle
                  ]
                );

              }


              try {

                const response =
                  await fetch(
                    root +
                    "products/" +
                    encodeURIComponent(
                      handle
                    ) +
                    ".js"
                  );


                if (!response.ok) {
                  return null;
                }


                const product =
                  await response.json();


                abhiWishlistDrawerProductCache[
                  handle
                ] = product;


                return product;


              } catch (error) {

                console.warn(
                  "Wishlist drawer product could not be loaded:",
                  handle,
                  error
                );

                return null;

              }

            }
          )

        )
      ).filter(Boolean);


    /* Remove deleted products */

    const validHandles =
      products.map(
        function (product) {
          return product.handle;
        }
      );


    if (
      validHandles.length !==
      wishlist.length
    ) {

      saveWishlist(
        validHandles
      );

      updateWishlistButtons();

      updateWishlistCount();

    }


    /* No valid products */

    if (!products.length) {

      body.innerHTML = `

        <div class="abhi-wishlist-drawer__empty">

          <div
            class="abhi-wishlist-drawer__empty-icon"
            aria-hidden="true"
          >
            ♡
          </div>

          <h3>
            Your wishlist is empty
          </h3>

          <p>
            Save your favourite sarees here for later.
          </p>

        </div>

      `;

      return;
    }


    /* Product list */

    body.innerHTML =
      products
        .map(
          function (product) {

            const image =
              product.featured_image ||
              (
                product.images &&
                product.images[0]
              ) ||
              "";


            const variant =
              product.variants &&
              (
                product.variants.find(
                  function (item) {
                    return item.available;
                  }
                ) ||
                product.variants[0]
              );


            const price =
              formatMoney(
                product.price
              );


            const comparePrice =
              product.compare_at_price &&
              product.compare_at_price >
                product.price
                ? formatMoney(
                    product.compare_at_price
                  )
                : "";

            const discountPercent =
              comparePrice
                ? Math.round(
                    (product.compare_at_price - product.price) * 100 /
                    product.compare_at_price
                  )
                : 0;


            return `

              <article
                class="abhi-wishlist-drawer__item"
                data-wishlist-drawer-item
                data-product-handle="${escapeHTML(
                  product.handle
                )}"
              >

                <a
                  href="${escapeHTML(
                    product.url
                  )}"
                  class="abhi-wishlist-drawer__image"
                >

                  <img
                    src="${escapeHTML(
                      image
                    )}"
                    alt="${escapeHTML(
                      product.title
                    )}"
                    loading="lazy"
                  >

                </a>


                <div class="abhi-wishlist-drawer__info">

                  <a
                    href="${escapeHTML(
                      product.url
                    )}"
                    class="abhi-wishlist-drawer__title"
                  >
                    ${escapeHTML(
                      product.title
                    )}
                  </a>


                  <div
                    class="abhi-wishlist-drawer__price"
                  >

                    <span>
                      ${price}
                    </span>

                    ${
                      comparePrice
                        ? `
                          <del>
                            ${comparePrice}
                          </del>
                        `
                        : ""
                    }

                    ${
                      discountPercent > 0
                        ? `<b class="abhi-wishlist-drawer__discount">${discountPercent}% OFF</b>`
                        : ""
                    }

                  </div>


                  ${
                      buildNativeAddToCartMarkup(
                        product,
                        variant,
                        {
                          formClass: "abhi-wishlist-drawer__form",
                          buttonClass: "abhi-add-to-bag abhi-wishlist-drawer__add",
                          sectionId: "abhiramam-wishlist-drawer"
                        }
                      )
                    }

                </div>


                <button
                  type="button"
                  class="abhi-wishlist-drawer__remove"
                  data-abhi-wishlist-remove
                  data-product-handle="${escapeHTML(
                    product.handle
                  )}"
                  aria-label="Remove ${escapeHTML(
                    product.title
                  )} from wishlist"
                >
                  <span class="abhi-wishlist-delete-icon" aria-hidden="true">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        class="remove-icon-top"
                        d="M8 6V5C8 4.44772 8.44772 4 9 4H15C15.5523 4 16 4.44772 16 5V6"
                        stroke="currentColor"
                        stroke-width="1.4"
                        stroke-linecap="round"
                      />

                      <path
                        d="M5 6H19"
                        stroke="currentColor"
                        stroke-width="1.4"
                        stroke-linecap="round"
                      />

                      <path
                        class="remove-icon-bottom"
                        d="M7 6L8 19C8.07692 20.0005 8.91409 20.75 9.91757 20.75H14.0824C15.0859 20.75 15.9231 20.0005 16 19L17 6"
                        stroke="currentColor"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>

                  <span class="visually-hidden">
                    Remove ${escapeHTML(product.title)} from wishlist
                  </span>
                </button>

              </article>

            `;

          }
        )
        .join("");


    /* Re-bind remove buttons (Add to Bag now uses the native
      Horizon product-form architecture, so bindAddToCart()
      is intentionally not called here). */

    bindWishlistRemove();

  }


  /* =========================================================
    HEADER WISHLIST BUTTON
  ========================================================= */

  function bindWishlistHeader() {

    document
      .querySelectorAll(
        ".abhi-header-wishlist"
      )
      .forEach(
        function (link) {

          if (
            link.dataset
              .abhiWishlistHeaderBound ===
            "true"
          ) {
            return;
          }


          link.dataset
            .abhiWishlistHeaderBound =
            "true";


          link.addEventListener(
            "click",
            function (event) {

              event.preventDefault();

              openWishlistDrawer();

            }
          );

        }
      );

  }


  /* =========================================================
    ESC TO CLOSE
  ========================================================= */

  document.addEventListener(
    "keydown",
    function (event) {

      if (
        event.key !== "Escape"
      ) {
        return;
      }


      const drawer =
        document.querySelector(
          "[data-abhi-wishlist-drawer]"
        );


      if (
        drawer &&
        drawer.classList.contains(
          "is-open"
        )
      ) {

        closeWishlistDrawer();

      }

    }
  );


  /* =========================================================
    WISHLIST DRAWER STYLES
  ========================================================= */

  function injectWishlistDrawerStyles() {

    if (
      document.getElementById(
        "abhi-wishlist-drawer-styles"
      )
    ) {
      return;
    }


    const style =
      document.createElement(
        "style"
      );


    style.id =
      "abhi-wishlist-drawer-styles";


    style.textContent = `

      .abhi-wishlist-drawer {
        position: fixed;
        inset: 0;
        z-index: 99999;
        visibility: hidden;
        pointer-events: none;
        transition: visibility 0s linear 0.3s;
      }

      .abhi-wishlist-drawer.is-open {
        visibility: visible;
        pointer-events: auto;
        transition-delay: 0s;
      }


      .abhi-wishlist-drawer__overlay {
        position: absolute;
        inset: 0;
        background: rgba(20, 10, 10, .38);
        opacity: 0;
        transition: opacity .25s ease;
      }


      .abhi-wishlist-drawer.is-open
      .abhi-wishlist-drawer__overlay {
        opacity: 1;
      }


      .abhi-wishlist-drawer__panel {
        position: absolute;
        top: 0;
        right: 0;
        width: var(--theme-drawer-width, var(--sidebar-width));
        max-width: 100%;
        height: 100dvh;
        border-left: var(--style-border-drawer);
        display: flex;
        flex-direction: column;
        background: var(--color-background);
        color: var(--color-foreground);
        box-shadow: none;
        transform: translateX(100%);
        transition: transform .3s ease;
      }

      @media screen and (max-width: 749px) {
        .abhi-wishlist-drawer__panel {
          position: absolute;
          top: 0;
          right: 0;
          left: auto;
          width: var(--theme-drawer-width, var(--sidebar-width));
          max-width: 100%;
          height: 100dvh;
          max-height: none;
        }
      }


      .abhi-wishlist-drawer.is-open
      .abhi-wishlist-drawer__panel {
        transform: translateX(0);
      }


      .abhi-wishlist-drawer__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--gap-xs);
        padding: 20px;
        flex-shrink: 0;
        color: var(--color-foreground);
      }


      .abhi-wishlist-drawer__heading {
        display: flex;
        align-items: center;
        gap: var(--gap-xs);
        min-width: 0;
      }

      .abhi-wishlist-drawer__heading h2 {
        margin: 0;
        font-size: 24px;
        line-height: var(--line-height-tight);
        font-family: var(--font-heading--family, inherit);
        color: var(--color-foreground);
      }

      .abhi-wishlist-drawer__count {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 22px;
        height: 22px;
        padding-inline: 0.2em;
        aspect-ratio: 1 / 1;
        flex-shrink: 0;
        box-sizing: border-box;

        border-radius: var(--style-border-radius-lg);
        background-color: rgb(var(--color-foreground-rgb) / 0.1);

        font-family: var(--font-paragraph--family);
        font-weight: var(--font-paragraph--weight);
        font-size: 13px;
        line-height: 1;
        color: var(--color-foreground);
        opacity: 1;
      }


      /* =====================================================
         CLOSE BUTTON — matches the theme's native
         .theme-drawer__close-button (cart drawer, search, etc.)
      ===================================================== */

      .abhi-wishlist-drawer__close {
        --button-icon-opacity: 0.65;
        --private-button-border-color: var(--color-border, rgba(0, 0, 0, .1));
        --private-button-shadow: 0 2px 6px 0 rgba(0, 0, 0, .06);

        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--private-button-border-color);
        border-radius: 50%;
        background: var(--color-background, transparent);
        color: var(--color-foreground, inherit);
        opacity: var(--button-icon-opacity);
        box-shadow: var(--private-button-shadow);
        font-size: 20px;
        line-height: 1;
        cursor: pointer;
        transition:
          background .2s ease,
          border-color .2s ease,
          opacity .2s ease,
          box-shadow .2s ease;
      }


      @supports (color: oklch(from red l c h)) {

        .abhi-wishlist-drawer__close {
          --contrast-color: oklch(from var(--color-background) clamp(0, (.6 / l - 1) * infinity, 1) 0 0);
          --button-icon-opacity: 1;
          --private-button-border-color: color-mix(in srgb, var(--contrast-color) 6%, transparent);
          --private-button-shadow: 0 2px 6px 0 var(--private-button-border-color);
          color: color-mix(in srgb, var(--contrast-color) 50%, transparent);
        }

      }


      .abhi-wishlist-drawer__close:hover {
        opacity: 1;
        background:
          color-mix(in srgb, var(--color-foreground, #5a2028) 6%, var(--color-background, transparent));
      }


      .abhi-wishlist-drawer__body {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        padding: 20px;
      }


      .abhi-wishlist-drawer__item {
        position: relative;
        display: grid;
        grid-template-columns: 86px 1fr;
        gap: var(--gap-md);
        padding-bottom: var(--gap-xl);
        margin-bottom: var(--gap-xl);
        border-bottom:
          var(--style-border-width)
          solid
          rgb(var(--color-foreground-rgb) / var(--opacity-10-25));
      }

      .abhi-wishlist-drawer__item:last-child {
        border-bottom: none;
        padding-bottom: 0;
        margin-bottom: 0;
      }


      .abhi-wishlist-drawer__image {
        display: block;
        width: 86px;
        aspect-ratio: 3 / 4;
        overflow: hidden;
        border-radius: 8px;
        background: var(--color-background-secondary, #f4eee6);
      }


      .abhi-wishlist-drawer__image img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }


      .abhi-wishlist-drawer__info {
        min-width: 0;
        padding-right: 24px;
      }


      .abhi-wishlist-drawer__title {
        display: block;
        color: inherit;
        text-decoration: none;
        font-size: 14px;
        line-height: 1.45;
        font-weight: 500;
        margin-bottom: 7px;
      }


      .abhi-wishlist-drawer__title:hover {
        text-decoration: underline;
      }


      /* Price styling, same as the Abhi product card / cart drawer */
      .abhi-wishlist-drawer__price {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        gap: 6px;
        margin-bottom: 12px;
        white-space: nowrap;
        color: var(--abhi-oxblood, #7c2b2b);
        font-family: var(--abhi-ui, "Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif);
        font-size: 13px;
        font-weight: 700;
      }


      .abhi-wishlist-drawer__price del {
        opacity: 1;
        color: var(--abhi-ink-faint, #8a8074);
        font-weight: 400;
        font-size: 12px;
        text-decoration: line-through;
      }


      .abhi-wishlist-drawer__discount {
        display: inline-flex;
        align-items: center;
        padding: 3px 7px;
        background: var(--abhi-ivory-deep, #f3ece1);
        color: var(--abhi-oxblood, #7c2b2b);
        font-family: var(--abhi-ui, "Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif);
        font-size: 9px;
        font-weight: 700;
        letter-spacing: 0.06em;
        line-height: 1.2;
      }


      .abhi-wishlist-drawer__add {
        min-height: 38px;
        padding: 8px 16px;
        font-size: 12px;
      }


      .abhi-wishlist-drawer__remove {
        position:absolute;
        top:-5px;
        right:0;

        width:34px;
        height:34px;

        display:flex;
        align-items:center;
        justify-content:center;

        padding:0;
        border:0;
        background:transparent;
        color:var(--color-foreground);

        opacity:.65;
        box-shadow:none;
        cursor:pointer;
      }

      .abhi-wishlist-drawer__remove:hover {
        opacity:1;
      }

      .abhi-wishlist-drawer__remove svg {
        display:block;
        width:20px;
        height:20px;
      }

      .abhi-wishlist-drawer__remove .remove-icon-bottom,
      .abhi-wishlist-drawer__remove .remove-icon-top {
        transition:
          transform var(--animation-speed)
          var(--animation-easing);
      }

      .abhi-wishlist-drawer__remove:hover .remove-icon-top {
        transform:
          translate(
            calc(-1 * var(--icon-stroke-width)),
            var(--icon-stroke-width)
          )
          rotate(-15deg);
      }

      .abhi-wishlist-drawer__remove:is(:hover,:active) .remove-icon-bottom {
        transform:translateY(var(--icon-stroke-width));
      }

      .abhi-wishlist-delete-icon {
        width: var(--icon-size-md, 20px);
        height: var(--icon-size-md, 20px);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .abhi-wishlist-delete-icon svg {
        display: block;
        width: 20px;
        height: 20px;
      }

      .abhi-wishlist-delete-icon .remove-icon-bottom,
      .abhi-wishlist-delete-icon .remove-icon-top {
        transition:
          transform var(--animation-speed)
          var(--animation-easing);
      }

      .abhi-wishlist-drawer__remove:hover .remove-icon-top {
        transform:
          translate(
            calc(-1 * var(--icon-stroke-width)),
            var(--icon-stroke-width)
          )
          rotate(-15deg);
      }

      .abhi-wishlist-drawer__remove:is(:hover, :active)
      .remove-icon-bottom {
        transform: translateY(var(--icon-stroke-width));
      }


      .abhi-wishlist-drawer__empty {
        min-height: 320px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 30px;
      }


      .abhi-wishlist-drawer__empty-icon {
        font-size: 46px;
        line-height: 1;
        margin-bottom: 18px;
        opacity: .5;
      }


      .abhi-wishlist-drawer__empty h3 {
        margin: 0 0 8px;
        font-size: 18px;
      }


      .abhi-wishlist-drawer__empty p {
        margin: 0;
        font-size: 13px;
        opacity: .65;
        line-height: 1.5;
      }


      .abhi-wishlist-drawer__loading {
        padding: 40px 20px;
        text-align: center;
        font-size: 13px;
        opacity: .65;
      }


      .abhi-wishlist-drawer__footer {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: var(--gap-xs);
        padding: 18px 20px;
        border-top:
          var(--style-border-width)
          solid
          rgb(var(--color-foreground-rgb) / var(--opacity-10-25));
        background: var(--color-background);
        flex-shrink: 0;
      }


      .abhi-wishlist-drawer__button {
        min-height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 16px;
        border-radius: 4px;
        text-decoration: none;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: .04em;
        text-transform: uppercase;
        transition:
          all .2s ease;
      }


      .abhi-wishlist-drawer__button--outline {
        border:
          1px solid
          #5a2028;
        color: #5a2028;
        background: transparent;
      }


      .abhi-wishlist-drawer__button--outline:hover {
        background: #5a2028;
        color: #fff;
      }


      .abhi-wishlist-drawer__button--primary {
        border:
          1px solid
          #5a2028;
        background: #5a2028;
        color: #fff;
      }


      .abhi-wishlist-drawer__button--primary:hover {
        background: #42171d;
        border-color: #42171d;
      }


      body.abhi-wishlist-drawer-open {
        overflow: hidden;
      }


      @media screen and (max-width: 749px) {

      .abhi-wishlist-drawer__panel {
        width: var(--theme-drawer-width, var(--sidebar-width));
        max-width: 100%;
      }

      .abhi-wishlist-drawer__header {
        padding:
          18px 16px;
      }

      .abhi-wishlist-drawer__body {
        padding:
          16px;
      }

      .abhi-wishlist-drawer__footer {
        padding:
          14px 16px;
      }

    }

    `;


    document.head.appendChild(
      style
    );

  }


  /* =========================================================
     QUICK VIEW
  ========================================================= */

  function createQuickView() {

    if (
      document.querySelector(
        ".abhi-qv-overlay"
      )
    ) {
      return;
    }


    const overlay =
      document.createElement(
        "div"
      );


    overlay.className =
      "abhi-qv-overlay";


    overlay.innerHTML = `
      <div
        class="abhi-qv-modal"
        role="dialog"
        aria-modal="true"
      >

        <div class="abhi-qv-media">

          <img
            src=""
            alt=""
          >

        </div>


        <div class="abhi-qv-content">

          <button
            type="button"
            class="abhi-qv-close"
            aria-label="Close quick view"
          >
            ×
          </button>


          <h2 class="abhi-qv-title"></h2>


          <div
            class="abhi-qv-rating"
          ></div>


          <div
            class="abhi-qv-price"
          ></div>


          <div class="abhi-qv-note">
            Premium sarees, carefully selected and packed for you.
          </div>


          <button
            type="button"
            class="abhi-add-to-bag abhi-qv-add"
          >
            Add to Bag
          </button>


          <a
            href="#"
            class="abhi-button abhi-button--outline abhi-qv-view"
            style="width:100%;margin-top:12px;"
          >
            View Full Product
          </a>

        </div>

      </div>
    `;


    document.body.appendChild(
      overlay
    );


    overlay
      .querySelector(
        ".abhi-qv-close"
      )
      .addEventListener(
        "click",
        closeQuickView
      );


    overlay.addEventListener(
      "click",
      function (event) {

        if (
          event.target ===
          overlay
        ) {

          closeQuickView();

        }

      }
    );


    document.addEventListener(
      "keydown",
      function (event) {

        if (
          event.key ===
            "Escape" &&
          overlay.classList.contains(
            "is-open"
          )
        ) {

          closeQuickView();

        }

      }
    );

  }


  function closeQuickView() {

    const overlay =
      document.querySelector(
        ".abhi-qv-overlay"
      );


    if (!overlay) {
      return;
    }


    overlay.classList.remove(
      "is-open"
    );


    document.body.style.overflow =
      "";

  }


  async function openQuickView(
    handle
  ) {

    createQuickView();


    const overlay =
      document.querySelector(
        ".abhi-qv-overlay"
      );


    const image =
      overlay.querySelector(
        ".abhi-qv-media img"
      );


    const title =
      overlay.querySelector(
        ".abhi-qv-title"
      );


    const price =
      overlay.querySelector(
        ".abhi-qv-price"
      );


    const rating =
      overlay.querySelector(
        ".abhi-qv-rating"
      );


    const addButton =
      overlay.querySelector(
        ".abhi-qv-add"
      );


    const viewLink =
      overlay.querySelector(
        ".abhi-qv-view"
      );


    title.textContent =
      "Loading...";

    price.textContent =
      "";

    rating.innerHTML =
      "";

    image.src =
      "";

    addButton.disabled =
      true;


    overlay.classList.add(
      "is-open"
    );


    document.body.style.overflow =
      "hidden";


    try {

      const response =
        await fetch(
          root +
          "products/" +
          handle +
          ".js"
        );


      if (!response.ok) {

        throw new Error(
          "Product not found"
        );

      }


      const product =
        await response.json();


      const variant =
        product.variants.find(
          function (item) {

            return item.available;

          }
        ) ||
        product.variants[0];


      image.src =
        product.featured_image ||
        (
          product.images &&
          product.images[0]
        ) ||
        "";


      image.alt =
        product.title;


      title.textContent =
        product.title;


      const currentPrice = formatMoney(product.price);
      const comparePrice = product.compare_at_price && product.compare_at_price > product.price 
        ? formatMoney(product.compare_at_price) 
        : "";

      price.innerHTML = comparePrice 
        ? `<span>${currentPrice}</span> <del style="font-weight:400; font-size:14px; opacity:0.6; margin-left:8px;">${comparePrice}</del>`
        : `<span>${currentPrice}</span>`;

      rating.innerHTML = `<div class="jdgm-widget jdgm-preview-badge" data-id="${product.id}"></div>`;
      
      initializeJudgeMeBadgesFor(rating, [product]);


      viewLink.href =
        "/products/" +
        product.handle;


      if (
        variant &&
        variant.available
      ) {

        addButton.disabled =
          false;


        addButton.dataset.variantId =
          variant.id;


        addButton.onclick =
          function () {

            addToCart(
              variant.id,
              addButton
            );

          };


      } else {

        addButton.disabled =
          true;

        addButton.textContent =
          "Sold Out";

      }

    } catch (error) {

      console.error(
        error
      );


      title.textContent =
        "Unable to load product";


      price.textContent =
        "";

    }

  }


  function bindQuickView() {

    document
      .querySelectorAll(
        "[data-abhi-quick-view]"
      )
      .forEach(
        function (button) {

          if (
            button.dataset.abhiBound ===
            "true"
          ) {
            return;
          }


          button.dataset.abhiBound =
            "true";


          button.addEventListener(
            "click",
            function () {

              const handle =
                button.dataset.productHandle;


              if (handle) {

                openQuickView(
                  handle
                );

              }

            }
          );

        }
      );

  }

  function bindAbhiTabbedProducts() {

    document
      .querySelectorAll("[data-abhi-tabs]")
      .forEach(function (tabList) {

        if (tabList.dataset.abhiBound === "true") {
          return;
        }

        tabList.dataset.abhiBound = "true";

        const buttons =
          tabList.querySelectorAll("[data-abhi-tab-button]");

        const section =
          tabList.closest(".abhi-tabbed-products");

        if (!section) {
          return;
        }

        buttons.forEach(function (button) {

          button.addEventListener("click", function () {

            const targetId =
              button.dataset.tabTarget;

            const targetPanel =
              section.querySelector(
                "#" + targetId
              );

            if (!targetPanel) {
              return;
            }

            /* Deactivate all buttons */
            buttons.forEach(function (btn) {

              btn.classList.remove("is-active");

              btn.setAttribute("aria-selected", "false");

            });

            /* Hide all panels */
            section
              .querySelectorAll("[data-abhi-tab-panel]")
              .forEach(function (panel) {

                panel.classList.remove("is-active");

                panel.hidden = true;

              });

            /* Activate clicked button + its panel */
            button.classList.add("is-active");

            button.setAttribute("aria-selected", "true");

            targetPanel.classList.add("is-active");

            targetPanel.hidden = false;

          });

        });

      });

  }

  function bindAbhiCategoryCarousel() {

    document
      .querySelectorAll("[data-abhi-carousel-track]")
      .forEach(function (track) {

        if (track.dataset.abhiBound === "true") {
          return;
        }

        track.dataset.abhiBound = "true";

        const wrap =
          track.closest(".abhi-carousel-wrap");

        if (!wrap) {
          return;
        }

        const prevBtn =
          wrap.querySelector("[data-abhi-carousel-prev]");

        const nextBtn =
          wrap.querySelector("[data-abhi-carousel-next]");

        const container =
          track.closest(".abhi-section__container") || wrap;

        const dotsWrap =
          container.querySelector("[data-abhi-carousel-dots]");

        let dotButtons = [];
        let pageCount = 0;
        let activeIndex = -1;
        let lastWidth = 0;

        function buildDots() {

          if (!dotsWrap) {
            return;
          }

          const count =
            track.clientWidth
              ? Math.max(1, Math.round(track.scrollWidth / track.clientWidth))
              : 0;

          /* Do nothing if the page count has not changed */
          if (!count || count === pageCount) {
            return;
          }

          pageCount = count;
          activeIndex = -1;

          dotsWrap.innerHTML = "";
          dotButtons = [];

          for (let i = 0; i < pageCount; i++) {

            const dot =
              document.createElement("button");

            dot.type = "button";
            dot.className = "abhi-carousel-dot";
            dot.setAttribute("aria-label", "Go to page " + (i + 1));

            dot.addEventListener("click", function () {

              track.scrollTo({
                left: track.clientWidth * i,
                behavior: "smooth"
              });

            });

            dotsWrap.appendChild(dot);

            dotButtons.push(dot);

          }

        }

        function updateArrowVisibility() {

          const maxScroll =
            track.scrollWidth - track.clientWidth;

          const atStart =
            track.scrollLeft <= 2;

          const atEnd =
            track.scrollLeft >= maxScroll - 2;

          if (prevBtn) {
            prevBtn.classList.toggle("is-hidden", atStart);
          }

          if (nextBtn) {
            nextBtn.classList.toggle("is-hidden", atEnd);
          }

          if (dotButtons.length) {

            let currentPage =
              Math.round(track.scrollLeft / track.clientWidth);

            if (track.scrollLeft >= maxScroll - 2) {
              currentPage = dotButtons.length - 1;
            }

            currentPage =
              Math.min(dotButtons.length - 1, Math.max(0, currentPage));

            /* Only touch the DOM when the active dot actually changes */
            if (currentPage !== activeIndex) {

              dotButtons.forEach(function (dot, index) {
                dot.classList.toggle("is-active", index === currentPage);
              });

              activeIndex = currentPage;

            }

          }

        }

        function scrollByAmount(direction) {

          const amount =
            track.clientWidth * 0.8 * direction;

          track.scrollBy({
            left: amount,
            behavior: "smooth"
          });

        }

        /* Mouse drag-to-scroll (desktop) */

        let isDragging = false;
        let dragStartX = 0;
        let dragScrollStart = 0;
        let dragMoved = false;

        track.addEventListener("mousedown", function (event) {

          isDragging = true;
          dragMoved = false;

          dragStartX = event.pageX;
          dragScrollStart = track.scrollLeft;

          track.classList.add("is-dragging");

          event.preventDefault();

        });

        window.addEventListener("mouseup", function () {

          if (!isDragging) {
            return;
          }

          isDragging = false;

          track.classList.remove("is-dragging");

        });

        window.addEventListener("mousemove", function (event) {

          if (!isDragging) {
            return;
          }

          const delta =
            event.pageX - dragStartX;

          if (Math.abs(delta) > 4) {
            dragMoved = true;
          }

          track.scrollLeft =
            dragScrollStart - delta;

        });

        track.addEventListener(
          "click",
          function (event) {

            if (dragMoved) {

              event.preventDefault();
              event.stopPropagation();

              dragMoved = false;

            }

          },
          true
        );

        if (prevBtn) {
          prevBtn.addEventListener("click", function () {
            scrollByAmount(-1);
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener("click", function () {
            scrollByAmount(1);
          });
        }

        track.addEventListener(
          "scroll",
          updateArrowVisibility,
          { passive: true }
        );

        /* Ignore resizes where only the height changed
           (mobile address bar showing/hiding while scrolling) */
        window.addEventListener(
          "resize",
          function () {

            if (track.clientWidth === lastWidth) {
              return;
            }

            lastWidth = track.clientWidth;

            buildDots();
            updateArrowVisibility();

          }
        );

        /* Set initial state once images/layout settle */
        lastWidth = track.clientWidth;
        buildDots();
        requestAnimationFrame(updateArrowVisibility);

      });

  }


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initAbhiTheme() {

    /* Wishlist drawer */
    injectWishlistDrawerStyles();

    createWishlistDrawer();

    /* Add to Bag */
    bindAddToCart();

    /* Wishlist native Add to Bag success feedback */
    bindWishlistNativeAddToCartFeedback();

    /* Wishlist buttons */
    bindWishlist();

    /* Header wishlist */
    bindWishlistHeader();

    /* Wishlist count */
    updateWishlistCount();

    /* Quick View */
    bindQuickView();

    /* Tabbed products */
    bindAbhiTabbedProducts();

    /* Category carousel */
    bindAbhiCategoryCarousel();

    /* Wishlist page */
    renderWishlistPage();

    /* Recently viewed */
    renderRecentlyViewed();

    /* Track current product */
    trackCurrentProductView();

    /* =========================================
       FIX: Relocate Account Modal to Body
    ========================================= */
    const accountModal = document.querySelector(".abhi-account-modal");
    if (accountModal && accountModal.parentNode !== document.body) {
      document.body.appendChild(accountModal);
    }

  }


  document.addEventListener(
    "DOMContentLoaded",
    initAbhiTheme
  );

  window.addEventListener(
    "pageshow",
    function () {

      renderRecentlyViewed();

      if (
        document.querySelector(
          "[data-abhi-wishlist-page]"
        )
      ) {
        renderWishlistPage();
      }

    }
  );


  /* Shopify Theme Editor */

  document.addEventListener(
    "shopify:section:load",
    function () {

      initAbhiTheme();

    }
  );

  /* Products added dynamically (collection page infinite scroll / filters) */

  document.addEventListener(
    "abhi:products-updated",
    function () {

      bindAddToCart();

      bindWishlist();

      bindQuickView();

    }
  );

})();